import { render, staticRenderFns } from "./PointsOfInterest.view.vue?vue&type=template&id=07225b92"
import script from "./PointsOfInterest.view.vue?vue&type=script&lang=ts"
export * from "./PointsOfInterest.view.vue?vue&type=script&lang=ts"
import style0 from "./PointsOfInterest.view.vue?vue&type=style&index=0&id=07225b92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFooter,VIcon,VRow})
